'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var remix = require('@remix-run/react');
var router = require('react-router-dom');

function _interopNamespaceDefault(e) {
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n.default = e;
  return Object.freeze(n);
}

var remix__namespace = /*#__PURE__*/_interopNamespaceDefault(remix);
var router__namespace = /*#__PURE__*/_interopNamespaceDefault(router);

/**
 * A Link component wrapping Link from Remix and react-router-dom
 * It can be used in interchangeably in a Remix or react-router-dom based SPA and work as expected
 * Means that devs don't need to worry about where an app is running and what API to use
 */ const Link = (props)=>{
    let isRouter = true;
    try {
        router__namespace.useLocation();
    } catch  {
        isRouter = false;
    }
    if (isRouter) {
        return /*#__PURE__*/ jsxRuntime.jsx(router__namespace.Link, {
            ...props
        });
    }
    return /*#__PURE__*/ jsxRuntime.jsx(remix__namespace.Link, {
        ...props
    });
};

exports.Link = Link;
//# sourceMappingURL=Link.cjs.map
